// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-wrapper {
  position: absolute;
  right: 38px;
  top: 0;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 2px;
  z-index: 10;
}

.eye-button {
  padding: 4px;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/Components/SharedComponents/InputIcons.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;AACJ","sourcesContent":[".icon-wrapper {\n    position: absolute;\n    right: 38px;\n    top: 0;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    z-index: 10;\n}\n\n.eye-button {\n    padding: 4px;\n    color: #555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
